import { createActions } from 'redux-actions';
var prefix = 'APP';
var actionTypes = ['SET_RESOURCES'];
export default createActions.apply(void 0, actionTypes.concat([{
  prefix: prefix
}]));